import React, { useState } from 'react'
import CardDashboard from '../../../../../components/moleculesv2/DashboardCard/CardDashboard'
import Text from '../../../../../components/Atomsv2/Text/Text'
import './CrudPaquetes.scss'
import Table from '../../../../../components/moleculesv2/Table/Table'
const CrudPaquetes = ({ data }) => {

    const [cards, setCards] = useState([
        {
            title: "1",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        },
        {
            title: "2",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        },
        {
            title: "3",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        }
    ])
    return (
        <div className="CrudPaquetes">
            <div className="cardsContainer">
                {
                    cards.map((card) => {
                        return (
                            <CardDashboard
                                title={card.title}
                                icon={card.icon}
                                iconColor={card.iconColor}
                                footer={card.footer}
                            >
                                {card.contenido}
                            </CardDashboard>
                        )
                    })
                }

            </div>
        
        </div>
    )
}
export default CrudPaquetes